module.exports = __webpack_public_path__ + "img/16-2.74bd92c0.png";